import { LitElement, html, css, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import styles from "./styles.css?inline";
import { template } from "./template";

@customElement("activity-history-is-grouping-busy")
export class ActivityHistoryIsGroupingBusy extends LitElement {
  static styles = css`
    ${unsafeCSS(styles)}
  `;

  render() {
    return template(this);
  }
} 